import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';
import {
  ApiListRelationship,
  ApiModel,
  ApiRelationship,
  ApiRelationshipIdentifier,
} from 'lib/interfaces/api';

const linkFor = (object: ApiRelationshipIdentifier) => {
  switch (object.type) {
    case ApiModel.Account:
      return `/dashboard/accounts/${object.id}`;
    case ApiModel.Transaction:
      return `/dashboard/transactions/${object.id}`;
    default:
      return '/dashboard';
  }
};

const TableCellForLinks = styled(TableCell)`
  line-height: ${({ theme }) => theme.text.paragraph.sm.lineHeight};

  & > a {
    display: block;
  }
`;

interface RelationsTableProps {
  relations: Record<string, ApiListRelationship | ApiRelationship>;
}

const RelationsTable = ({ relations }: RelationsTableProps) => {
  return (
    <Table aria-label='Relations'>
      <TableHead>
        <TableRow>
          <TableHeaderCell style={{ width: '35%' }}>Key</TableHeaderCell>
          <TableHeaderCell>Object(s)</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(relations).map(([key, objects]) => (
          <TableRow key={key}>
            <TableCell>{key}</TableCell>
            <TableCellForLinks>
              {objects.data != null &&
                (Array.isArray(objects.data) ? (
                  <>
                    {objects.data.map((o) => (
                      <Link key={o.id} to={linkFor(o)}>
                        {o.id}
                      </Link>
                    ))}
                  </>
                ) : (
                  <Link to={linkFor(objects.data)}>{objects.data.id}</Link>
                ))}
            </TableCellForLinks>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default RelationsTable;
